/**
 * Offres et prix (docs/BACKLOG.md T5).
 *
 * Le prix vit ici, dans le module partagé, pour une raison précise : le
 * serveur **recalcule** le montant à partir du plan et ne fait jamais confiance
 * au montant envoyé par le navigateur. Deux constantes qui divergeraient entre
 * le front et les fonctions produiraient soit un refus incompréhensible pour
 * l'utilisateur, soit un paiement au mauvais prix.
 *
 * Prix unique, révisé le 10/08/2026 : le parrainage n'accorde plus de remise,
 * il ouvre le second diagnostic à 90 jours. Aucune réduction ne dépend du
 * comportement — donc aucun montant à recalculer selon le profil.
 */
export const PLANS = {
    /** Le rapport seul. */
    report: 3000,
    /** Rapport + accompagnement Propulse. */
    bundle: 9000,
    /**
     * Le livrable de l'axe dirigeant — arbitrage du 18/08/2026.
     *
     * Deux prix sur un même site se tiennent parce que les deux livrables
     * diffèrent : le rapport salarié porte sur les tâches d'une personne, celui-ci
     * sur les postes d'une entreprise entière. Et c'est ce prix-là qui rend
     * l'acquisition payante possible — elle ne ferme pas à 3 000 F, c'est
     * l'arbitrage du 10/08 qui avait réduit la croissance au seul partage.
     */
    entreprise: 15000,
};
export const PLAN_IDS = Object.keys(PLANS);
export function estPlan(valeur) {
    return typeof valeur === "string" && valeur in PLANS;
}
/**
 * Montant dû, en francs CFA. Source unique de vérité, côté serveur comme côté
 * navigateur.
 *
 * @throws si le plan est inconnu — un plan inventé ne doit pas retomber
 * silencieusement sur le tarif le moins cher.
 */
export function montantDuPlan(plan) {
    if (!estPlan(plan))
        throw new Error(`plan inconnu : ${String(plan)}`);
    return PLANS[plan];
}
